export const MARKETPLACE = true;
export const MARKETPLACE_LIST = false;
export const MARKETPLACE_LIST_FOR_NON_PREMIUM = false;
export const MARKETPLACE_RELIST = true;

// Shows the AI-mode toggle in the search bar and the "Not sure what to search for?" CTA in its panel.
export const showAiModeOption = false;
